import { Component } from "react";
import moment from "moment";
import MetabaseDashboard from "../../../components/metabase/MetabaseDashboard";
import { getMetabaseQuestionDownloadUrl } from "../../../components/metabase/MetabaseFrame";
import { MetabaseSIISReportName, MetabaseSIISReportQuestionId } from "../../../utils/AppSetting";
// import { getAuditContext, getAuthProps } from "../../../utils/AuthenticationLibrary";


export default class SIISMonthlyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportDate: moment().format("YYYY-MM-DD"),
      showReportFrame: false,
      reportFrameKey: 0,
      downloadUrl: "",
    };
  }

  generateSIISMonthlyReport = () => {
    this.setState((prevState) => ({
      showReportFrame: true,
      reportFrameKey: prevState.reportFrameKey + 1,
      downloadUrl: "",
    }));
  };

  handleFramesResolved = (frames) => {
    const frame = Array.isArray(frames) ? frames[0] : null;
    const downloadUrl = frame
      ? frame.downloadUrl || getMetabaseQuestionDownloadUrl(frame.src, "xlsx")
      : "";

    this.setState({ downloadUrl });
  };

  downloadSIISMonthlyReport = () => {
    if (!this.state.downloadUrl) {
      return;
    }

    window.open(this.state.downloadUrl, "_blank", "noopener,noreferrer");
  };

  getSIISMonthlyReportFrame = () => {
    return {
      id: 1,
      title: "",
      questionId: MetabaseSIISReportQuestionId,
      expMinutes: 10,
      bordered: false,
      titled: false,
      parameters: {},
      fallbackUrl: `https://sgtechba.flyingcapetech.com/question/${MetabaseSIISReportName}`,
      height: 900,
      showDownloadButton: false,
      downloadLabel: "Download Results",
    };
  };

  render() {
    return (
      <div className="main-body-section finance-body-sec">
        <div className="bg-white">
          <div className="grid grid-cols-12 gap-6 w-full px-8 py-10 items-end">
            <div className="col-span-3">
              <label
                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                htmlFor="siisMonthlyReportDate"
              >
                Date
              </label>
              <div className="">
                <input
                  id="siisMonthlyReportDate"
                  name="siisMonthlyReportDate"
                  type="date"
                  className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg bg-[#e9e9ea] text-[#6b7280] cursor-not-allowed opacity-70"
                  value={this.state.reportDate}
                  readOnly
                  disabled
                />
              </div>
            </div>
            <div className="col-span-6 mb-1 flex gap-4">
              <button
                className="btn btn-red text-xl border text-white mt-8"
                onClick={() => this.generateSIISMonthlyReport()}
              >
                Generate Report
              </button>
              {this.state.downloadUrl ? (
                <button
                  type="button"
                  className={`btn text-xl border text-white mt-8 btn-red`}
                  onClick={() => this.downloadSIISMonthlyReport()}
                >
                  Download Results
                </button>
              ) : null}
            </div>
          </div>
        </div>
        {this.state.showReportFrame ? (
          <div className="mt-0">
            <MetabaseDashboard
              key={this.state.reportFrameKey}
              title=""
              frameCount={1}
              frames={[this.getSIISMonthlyReportFrame()]}
              className="px-6"
              onFramesResolved={this.handleFramesResolved}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
